const initVideoButton = () => {
  const videoContainers = document.querySelectorAll('.km_video-container');
   videoContainers.forEach(container => {
    const video = container.querySelector('video');
    const playButton = container.querySelector('.km_video--play-button');
    if (video && playButton) {
      // Hide the controls initially
      video.controls = false;

      playButton.addEventListener('click', function () {
        if (video.paused) {
          video.controls = true;
          video.play();
          playButton.style.display = 'none';
        } else {
          video.pause();
        }
      });

      video.addEventListener('pause', function () {
        playButton.style.display = 'flex';
        video.controls = false;
      });

      video.addEventListener('play', function () {
        playButton.style.display = 'none';
      });
    }
  });
};
export default initVideoButton;





